<div class="modal-header ai-stats-header">
	<div class="d-flex align-items-center gap-2">
		<img src="../../../../assets/images/control-panel/inteligencia artificial.png" width="32"
			alt="IA">
		<h5 class="modal-title m-0">Estadísticas de consumo de IA</h5>
	</div>
	<button type="button" class="close" aria-label="Close" (click)="closeModal()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body ai-stats-body">

	<!-- KPIs -->
	<div class="kpi-row" *ngIf="stats">
		<div class="kpi-card">
			<span class="kpi-value">{{ formatNumber(stats.totalCalls) }}</span>
			<span class="kpi-label">Llamadas totales</span>
		</div>
		<div class="kpi-card kpi-cost">
			<span class="kpi-value">{{ formatUsd(stats.totalCostUsd) }}</span>
			<span class="kpi-label">Coste estimado (USD)</span>
		</div>
		<div class="kpi-card">
			<span class="kpi-value">{{ formatNumber(stats.totalTokens) }}</span>
			<span class="kpi-label">Tokens totales</span>
		</div>
		<div class="kpi-card">
			<span class="kpi-value">{{ formatNumber(stats.totalUsers) }}</span>
			<span class="kpi-label">Usuarios activos</span>
		</div>
		<div class="kpi-card">
			<span class="kpi-value">{{ formatNumber(stats.totalPromptTokens) }}</span>
			<span class="kpi-label">Tokens prompt</span>
		</div>
		<div class="kpi-card">
			<span class="kpi-value">{{ formatNumber(stats.totalCompletionTokens) }}</span>
			<span class="kpi-label">Tokens completion</span>
		</div>
		<div class="kpi-card">
			<span class="kpi-value">{{ stats.avgTokensPerCall | number:'1.0-0' }}</span>
			<span class="kpi-label">Promedio / llamada</span>
		</div>
	</div>

	<!-- Filters -->
	<div class="filters-row">
		<div class="filter-group">
			<label>Usuario</label>
			<input type="text" class="form-control form-control-sm" placeholder="Nombre, email o ID..."
				[(ngModel)]="filterUser">
		</div>
		<div class="filter-group">
			<label>Feature</label>
			<select class="form-control form-control-sm" [(ngModel)]="filterFeature">
				<option value="">Todas</option>
				<option *ngFor="let f of filterOptions.features" [value]="f">{{ f }}</option>
			</select>
		</div>
		<div class="filter-group">
			<label>Modelo</label>
			<select class="form-control form-control-sm" [(ngModel)]="filterModel">
				<option value="">Todos</option>
				<option *ngFor="let m of filterOptions.models" [value]="m">{{ m }}</option>
			</select>
		</div>
		<div class="filter-group">
			<label>Proveedor</label>
			<select class="form-control form-control-sm" [(ngModel)]="filterProvider">
				<option value="">Todos</option>
				<option *ngFor="let p of filterOptions.providers" [value]="p">{{ p }}</option>
			</select>
		</div>
		<div class="filter-group">
			<label>Desde</label>
			<input type="date" class="form-control form-control-sm" [(ngModel)]="filterStartDate">
		</div>
		<div class="filter-group">
			<label>Hasta</label>
			<input type="date" class="form-control form-control-sm" [(ngModel)]="filterEndDate">
		</div>
		<div class="filter-actions">
			<button class="btn btn-sm btn-primary" (click)="applyFilters()">Filtrar</button>
			<button class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">Limpiar</button>
		</div>
	</div>

	<!-- Tabs -->
	<ul class="nav nav-tabs ai-stats-tabs">
		<li class="nav-item">
			<a class="nav-link" [class.active]="activeTab === 'charts'" (click)="switchTab('charts')">
				Gráficas
			</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" [class.active]="activeTab === 'summaries'" (click)="switchTab('summaries')">
				Resumen por usuario
			</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" [class.active]="activeTab === 'logs'" (click)="switchTab('logs')">
				Logs detallados
			</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" [class.active]="activeTab === 'openai'" (click)="switchTab('openai')">
				Coste real OpenAI
			</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" [class.active]="activeTab === 'reconciliation'" (click)="switchTab('reconciliation')">
				Reconciliación
			</a>
		</li>
	</ul>

	<!-- Tab: Charts -->
	<div class="tab-content" *ngIf="activeTab === 'charts'">
		<div class="charts-grid" *ngIf="!loadingStats && stats">
			<div class="chart-container">
				<canvas #chartFeature></canvas>
			</div>
			<div class="chart-container">
				<canvas #chartModel></canvas>
			</div>
			<div class="chart-container">
				<canvas #chartTopUsers></canvas>
			</div>
			<div class="chart-container">
				<canvas #chartTimeSeries></canvas>
			</div>
		</div>
		<div class="text-center py-4" *ngIf="loadingStats">
			<div class="spinner-border" role="status" style="color: #00c4b3">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
	</div>

	<!-- Tab: Summaries -->
	<div class="tab-content" *ngIf="activeTab === 'summaries'">
		<div class="table-responsive" *ngIf="!loadingSummaries">
			<table class="table table-sm table-hover ai-stats-table">
				<thead>
					<tr>
						<th class="sortable" (click)="sortSummariesBy('firstName')">
							Usuario {{ getSortIcon('firstName', summarySortBy, summarySortDir) }}
						</th>
						<th>Email</th>
						<th class="sortable text-right" (click)="sortSummariesBy('totalCalls')">
							Llamadas {{ getSortIcon('totalCalls', summarySortBy, summarySortDir) }}
						</th>
						<th class="sortable text-right" (click)="sortSummariesBy('promptTokens')">
							Prompt {{ getSortIcon('promptTokens', summarySortBy, summarySortDir) }}
						</th>
						<th class="sortable text-right" (click)="sortSummariesBy('completionTokens')">
							Completion {{ getSortIcon('completionTokens', summarySortBy, summarySortDir) }}
						</th>
						<th class="sortable text-right" (click)="sortSummariesBy('totalTokens')">
							Total tokens {{ getSortIcon('totalTokens', summarySortBy, summarySortDir) }}
						</th>
						<th class="sortable text-right cost-col" (click)="sortSummariesBy('costUsd')">
							Coste (USD) {{ getSortIcon('costUsd', summarySortBy, summarySortDir) }}
						</th>
						<th class="sortable" (click)="sortSummariesBy('lastUpdated')">
							Última actividad {{ getSortIcon('lastUpdated', summarySortBy, summarySortDir) }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let s of filteredSummaries">
						<td>{{ s.firstName }} {{ s.surname }}</td>
						<td class="text-muted small">{{ s.mail }}</td>
						<td class="text-right">{{ formatNumber(s.totalCalls) }}</td>
						<td class="text-right">{{ formatNumber(s.promptTokens) }}</td>
						<td class="text-right">{{ formatNumber(s.completionTokens) }}</td>
						<td class="text-right font-weight-bold">{{ formatNumber(s.totalTokens) }}</td>
						<td class="text-right cost-col">{{ formatUsd(s.costUsd) }}</td>
						<td>{{ formatDate(s.lastUpdated) }}</td>
					</tr>
					<tr *ngIf="filteredSummaries.length === 0">
						<td colspan="8" class="text-center text-muted py-3">No hay datos disponibles</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center py-4" *ngIf="loadingSummaries">
			<div class="spinner-border" role="status" style="color: #00c4b3">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
	</div>

	<!-- Tab: Logs -->
	<div class="tab-content" *ngIf="activeTab === 'logs'">
		<div class="table-responsive" *ngIf="!loadingLogs">
			<table class="table table-sm table-hover ai-stats-table">
				<thead>
					<tr>
						<th class="sortable" (click)="sortLogsBy('callDate')">
							Fecha {{ getSortIcon('callDate', logSortBy, logSortDir) }}
						</th>
						<th>Usuario</th>
						<th class="sortable" (click)="sortLogsBy('feature')">
							Feature {{ getSortIcon('feature', logSortBy, logSortDir) }}
						</th>
						<th class="sortable" (click)="sortLogsBy('model')">
							Modelo {{ getSortIcon('model', logSortBy, logSortDir) }}
						</th>
						<th class="sortable" (click)="sortLogsBy('provider')">
							Proveedor {{ getSortIcon('provider', logSortBy, logSortDir) }}
						</th>
						<th>Tipo</th>
						<th class="sortable text-right" (click)="sortLogsBy('totalTokens')">
							Tokens {{ getSortIcon('totalTokens', logSortBy, logSortDir) }}
						</th>
						<th class="sortable text-right cost-col" (click)="sortLogsBy('costUsd')">
							Coste (USD) {{ getSortIcon('costUsd', logSortBy, logSortDir) }}
						</th>
						<th>Descripción</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let l of logs">
						<td class="text-nowrap">{{ formatDate(l.callDate) }}</td>
						<td>
							<span>{{ l.firstName }} {{ l.surname }}</span>
							<br>
							<small class="text-muted">{{ l.mail }}</small>
						</td>
						<td>
							<span class="badge badge-feature">{{ l.feature }}</span>
						</td>
						<td>{{ l.model || '-' }}</td>
						<td>{{ l.provider }}</td>
						<td>
							<span class="badge badge-type">{{ l.usageType }}</span>
						</td>
						<td class="text-right">
							<span [class.tokens-estimated]="l.tokensEstimated"
								[title]="l.tokensEstimated ? 'Valor estimado (la API no devuelve tokens para este tipo)' : ''">
								{{ formatNumber(l.totalTokens) }}
								<span *ngIf="l.tokensEstimated" class="estimated-badge">~</span>
							</span>
						</td>
						<td class="text-right cost-col">{{ formatUsd(l.costUsd) }}</td>
						<td class="description-cell" [title]="l.description">{{ l.description }}</td>
					</tr>
					<tr *ngIf="logs.length === 0">
						<td colspan="9" class="text-center text-muted py-3">No hay logs disponibles</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- Pagination -->
		<div class="pagination-row" *ngIf="logTotalPages > 1">
			<span class="pagination-info">
				Mostrando {{ logPage * logSize + 1 }}-{{ logPage * logSize + logs.length }} de {{ logTotalElements }}
			</span>
			<nav>
				<ul class="pagination pagination-sm mb-0">
					<li class="page-item" [class.disabled]="logPage === 0">
						<a class="page-link" (click)="goToPage(0)">&laquo;</a>
					</li>
					<li class="page-item" [class.disabled]="logPage === 0">
						<a class="page-link" (click)="goToPage(logPage - 1)">&lsaquo;</a>
					</li>
					<li class="page-item" *ngFor="let p of getPageNumbers()" [class.active]="p === logPage">
						<a class="page-link" (click)="goToPage(p)">{{ p + 1 }}</a>
					</li>
					<li class="page-item" [class.disabled]="logPage >= logTotalPages - 1">
						<a class="page-link" (click)="goToPage(logPage + 1)">&rsaquo;</a>
					</li>
					<li class="page-item" [class.disabled]="logPage >= logTotalPages - 1">
						<a class="page-link" (click)="goToPage(logTotalPages - 1)">&raquo;</a>
					</li>
				</ul>
			</nav>
		</div>

		<div class="text-center py-4" *ngIf="loadingLogs">
			<div class="spinner-border" role="status" style="color: #00c4b3">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
	</div>

	<!-- Tab: OpenAI billing real -->
	<div class="tab-content" *ngIf="activeTab === 'openai'">

		<div class="openai-toolbar">
			<div class="openai-info">
				<div *ngIf="openAiData?.lastSyncedAt">
					Última sincronización: <strong>{{ formatDate(openAiData!.lastSyncedAt!) }}</strong>
				</div>
				<div *ngIf="!openAiData?.lastSyncedAt" class="text-muted">
					Sin sincronizaciones todavía. Pulsa <em>Sincronizar ahora</em> después de configurar la admin key.
				</div>
				<div class="small text-muted" *ngIf="openAiData">
					<span *ngIf="openAiData.projectScope">
						Ámbito: proyecto <code>{{ openAiData.projectScope }}</code>
					</span>
					<span *ngIf="!openAiData.projectScope">
						Ámbito: <strong>toda la organización OpenAI</strong>
					</span>
				</div>
			</div>
			<button class="btn btn-sm btn-primary" (click)="syncOpenAiCosts()" [disabled]="syncing">
				<span *ngIf="!syncing">Sincronizar ahora</span>
				<span *ngIf="syncing">Sincronizando...</span>
			</button>
		</div>

		<div class="alert alert-warning" *ngIf="lastSyncStatus === 'SKIPPED'">
			<strong>Sincronización omitida.</strong> {{ lastSyncMessage }}
		</div>
		<div class="alert alert-danger" *ngIf="lastSyncStatus === 'FAILED'">
			<strong>Sincronización fallida.</strong> {{ lastSyncMessage }}
		</div>
		<div class="alert alert-success" *ngIf="lastSyncStatus === 'COMPLETED'">
			Sincronización completada. {{ lastSyncMessage }}
		</div>

		<div class="kpi-row" *ngIf="openAiData">
			<div class="kpi-card kpi-cost">
				<span class="kpi-value">{{ formatUsd(openAiData.totalCostUsd) }}</span>
				<span class="kpi-label">Coste real (USD)</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value">{{ formatNumber(openAiData.totalRequests) }}</span>
				<span class="kpi-label">Requests</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value">{{ formatNumber(openAiData.totalInputTokens) }}</span>
				<span class="kpi-label">Tokens entrada</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value">{{ formatNumber(openAiData.totalOutputTokens) }}</span>
				<span class="kpi-label">Tokens salida</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value">{{ formatNumber(openAiData.totalCachedInputTokens) }}</span>
				<span class="kpi-label">Tokens cacheados</span>
			</div>
		</div>

		<div class="table-responsive" *ngIf="openAiData && !loadingOpenAi">
			<h6 class="section-title">Por usuario</h6>
			<table class="table table-sm table-hover">
				<thead>
					<tr>
						<th>Usuario</th>
						<th>user_id (OpenAI)</th>
						<th class="text-right">Requests</th>
						<th class="text-right">Tokens entrada</th>
						<th class="text-right">Tokens salida</th>
						<th class="text-right cost-col">Coste (USD)</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let u of openAiData.byUser">
						<td>
							<span *ngIf="u.firstName">{{ u.firstName }} {{ u.surname }}</span>
							<small class="text-muted d-block" *ngIf="u.mail">{{ u.mail }}</small>
						</td>
						<td><code class="small">{{ u.userIdRaw || '—' }}</code></td>
						<td class="text-right">{{ formatNumber(u.numModelRequests) }}</td>
						<td class="text-right">{{ formatNumber(u.inputTokens) }}</td>
						<td class="text-right">{{ formatNumber(u.outputTokens) }}</td>
						<td class="text-right cost-col">{{ formatUsd(u.costUsd) }}</td>
					</tr>
					<tr *ngIf="openAiData.byUser.length === 0">
						<td colspan="6" class="text-center text-muted py-3">No hay datos en este rango.</td>
					</tr>
				</tbody>
			</table>

			<h6 class="section-title">Por modelo</h6>
			<table class="table table-sm table-hover">
				<thead>
					<tr>
						<th>Modelo</th>
						<th class="text-right">Requests</th>
						<th class="text-right">Tokens entrada</th>
						<th class="text-right">Tokens salida</th>
						<th class="text-right cost-col">Coste (USD)</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let m of openAiData.byModel">
						<td>{{ m.model || '—' }}</td>
						<td class="text-right">{{ formatNumber(m.numModelRequests) }}</td>
						<td class="text-right">{{ formatNumber(m.inputTokens) }}</td>
						<td class="text-right">{{ formatNumber(m.outputTokens) }}</td>
						<td class="text-right cost-col">{{ formatUsd(m.costUsd) }}</td>
					</tr>
					<tr *ngIf="openAiData.byModel.length === 0">
						<td colspan="5" class="text-center text-muted py-3">No hay datos en este rango.</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="sync-history" *ngIf="syncHistory.length > 0">
			<h6 class="section-title">Histórico de sincronizaciones</h6>
			<table class="table table-sm">
				<thead>
					<tr>
						<th>Fecha</th>
						<th>Origen</th>
						<th>Estado</th>
						<th class="text-right">Registros</th>
						<th>Mensaje</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let s of syncHistory">
						<td>{{ formatDate(s.syncStartedAt) }}</td>
						<td>{{ s.triggerSource }}</td>
						<td>
							<span class="badge" [class.badge-success]="s.status === 'SUCCESS'"
								[class.badge-warning]="s.status === 'SKIPPED'"
								[class.badge-danger]="s.status === 'FAILED'"
								[class.badge-info]="s.status === 'RUNNING'">{{ s.status }}</span>
						</td>
						<td class="text-right">{{ s.recordsImported }}</td>
						<td class="small text-muted" [title]="s.errorMessage">{{ s.errorMessage || '—' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="text-center py-4" *ngIf="loadingOpenAi">
			<div class="spinner-border" role="status" style="color: #00c4b3">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
	</div>

	<!-- Tab: Reconciliation -->
	<div class="tab-content" *ngIf="activeTab === 'reconciliation'">

		<div class="kpi-row" *ngIf="reconciliation">
			<div class="kpi-card">
				<span class="kpi-value">{{ formatUsd(reconciliation.totalLocalUsd) }}</span>
				<span class="kpi-label">Coste estimado (Salware)</span>
			</div>
			<div class="kpi-card kpi-cost">
				<span class="kpi-value">{{ formatUsd(reconciliation.totalRealUsd) }}</span>
				<span class="kpi-label">Coste real (OpenAI)</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value" [class.text-danger]="(reconciliation.totalDifferenceUsd || 0) > 0"
					[class.text-success]="(reconciliation.totalDifferenceUsd || 0) <= 0">
					{{ formatUsd(reconciliation.totalDifferenceUsd) }}
				</span>
				<span class="kpi-label">Diferencia</span>
			</div>
			<div class="kpi-card">
				<span class="kpi-value">{{ reconciliation.totalDifferencePct | number:'1.0-2' }}%</span>
				<span class="kpi-label">Desviación %</span>
			</div>
		</div>

		<div class="table-responsive" *ngIf="reconciliation && !loadingReconciliation">
			<table class="table table-sm table-hover">
				<thead>
					<tr>
						<th>Usuario</th>
						<th class="text-right">Local (USD)</th>
						<th class="text-right cost-col">Real (USD)</th>
						<th class="text-right">Diferencia</th>
						<th class="text-right">%</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let i of reconciliation.items">
						<td>
							{{ i.firstName }} {{ i.surname }}
							<small class="text-muted d-block" *ngIf="i.mail">{{ i.mail }}</small>
						</td>
						<td class="text-right">{{ formatUsd(i.costUsdLocal) }}</td>
						<td class="text-right cost-col">{{ formatUsd(i.costUsdReal) }}</td>
						<td class="text-right" [class.text-danger]="(i.difference || 0) > 0"
							[class.text-success]="(i.difference || 0) <= 0">
							{{ formatUsd(i.difference) }}
						</td>
						<td class="text-right">{{ i.differencePct | number:'1.0-2' }}%</td>
					</tr>
					<tr *ngIf="reconciliation.items.length === 0">
						<td colspan="5" class="text-center text-muted py-3">
							No hay datos para reconciliar. Sincroniza primero la pestaña <em>Coste real OpenAI</em>.
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="text-center py-4" *ngIf="loadingReconciliation">
			<div class="spinner-border" role="status" style="color: #00c4b3">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
	</div>

</div>
